import { FC } from 'react'

const HomePage:FC = () => {
  return (
    <div>HomePage</div>
  )
}

export default HomePage;
